import React, { FC, useEffect, useRef } from 'react'
import { FooterInner, FooterOuter, FooterSitemap } from './style'

//* utils
import { URLS } from '../../../constants/environment.constants'
import {
  LanguageSelect as LanguageSelectorItems,
  LocaleCodes,
} from '../../../constants/localization.constants'
import { MenuNav } from '../../../models/others/menuNav'
import { renderFooterLinks } from './utils/builder'
import { constructSocialObject, loadOneTrust, oneTrustCustomWinLoad } from './utils/helperFns'

//* components
import Legal from './subcomponents/legal'
import SocialIcons from './subcomponents/social'
import TopHatLinks from './subcomponents/topHatLinks'

type Props = {
  footerData: MenuNav
  locale: string
}

const NewFooter: FC<Props> = ({ footerData, locale }) => {
  if (!footerData) return null
  const languageSelector = useRef<any>()
  const langCode = footerData?.node_locale || LocaleCodes.ENGLISH.code

  //* remove Spanish
  const LanguageSelect: any = { rows: [] }
  LanguageSelect.rows = LanguageSelectorItems?.rows?.filter((item: any) => item.title !== 'Spanish')

  const language =
    LanguageSelect?.rows?.filter((item: any) => item.code === locale)?.[0]?.title || 'English'

  const localePage =
    LanguageSelect?.rows?.filter((item: any) => item.code === locale)?.[0]?.href || URLS.PROD

  const socialData = footerData.socialMediaFooterOnly
    ? constructSocialObject(footerData.socialMediaFooterOnly)
    : {}

  const closeLanguageSelector = (e: any) => {
    if (!e.target.classList.contains('Footer__LanguageSelector'))
      languageSelector?.current?.classList?.remove('LanguageSelector--Active')
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      const WeChatPopupResize = document.getElementById('popover_wechat')
      if (window.innerWidth > 767) {
        WeChatPopupResize?.classList.remove('open')
      }
    })

    window.addEventListener('click', closeLanguageSelector, false)

    if (langCode === LocaleCodes.CHINESE.code) {
      oneTrustCustomWinLoad(function () {
        loadOneTrust(500)
      })
    }

    return () => {
      return window.removeEventListener('click', closeLanguageSelector, false)
    }
  }, [])

  return (
    <FooterOuter>
      <FooterInner>
        <TopHatLinks
          localePage={localePage}
          langCode={langCode}
          topHatLinks={footerData?.topHatLinks}
          languageSelector={languageSelector}
          language={language}
        />

        <FooterSitemap>{renderFooterLinks(footerData?.menuGroups)}</FooterSitemap>

        {Object.keys(socialData)?.length > 0 && (
          <SocialIcons socialData={socialData} langCode={langCode} />
        )}

        {footerData?.legalFooterOnly?.length && (
          <Legal
            legalLinks={footerData.legalFooterOnly}
            socialData={socialData}
            langCode={langCode}
          />
        )}
      </FooterInner>
    </FooterOuter>
  )
}

export default NewFooter
